import React, { useEffect, useState } from 'react';
import { Card, Col } from 'reactstrap';
import { AreaChartComponent } from './AreaChartComponent';
import { ColumnChartComponent } from './ColumnChartComponent';
import { IQuestion } from './index';
import { buildHTMLSubtitle } from './utils';

interface IQuestionTrendContainerProps {
  question: IQuestion
  avidLabel: string
  surveyLabel: string
  periodLabel: string
  segmentName: string
  segmentCategory: string
}

export function QuestionTrendContainer(props: IQuestionTrendContainerProps) {
  const [highchartsDataPoints, setHighchartsDataPoints] = useState([]);
  const { avidLabel, surveyLabel, periodLabel, segmentName, segmentCategory, question } = props
  const { small_text, qid, val, values, avannis, label, drill_to_drilldown } = question
  let overall = 0;
  let net = 0;
  let netString = '0';
  let color = '#a3a3a3';
  let questionAbbreviation = '';

  if (question.values.length > 0) {
    net = question.values[question.values.length - 1].net;
    netString = net > 0 ? `+${net.toString()}` : net.toString();
    color = net > 0 ? '#00cc00' : color;
    color = net < 0 ? '#B30838' : color;
    overall = question.values[question.values.length - 1].overall;
    questionAbbreviation = question.values[0].abbr;
  }

  const htmlSubtitle = buildHTMLSubtitle(
    overall.toString(),
    netString,
    color,
    avidLabel,
    surveyLabel,
    periodLabel,
    label,
    segmentName,
    segmentCategory,
    questionAbbreviation,
    qid,
    val,
    small_text,
    drill_to_drilldown,
    question.values.length > 1
  )

  useEffect(() => {
    let newDataPoints: any[];
    newDataPoints = values.map((point, index) => {
      if (index === (values.length - 1)) {
        return {
          y: (isNaN(point.overall) ? 0 : Number(point.overall)),
          interviews: point.surveys,
          dataLabels: {
            enabled: true,
            format: '{y}%'
          }
        }
      } else {
        return {
          y: (isNaN(point.overall) ? 0 : Number(point.overall)),
          interviews: point.surveys
        }
      }
    })
    if (values.length < 3) {
      newDataPoints = [...newDataPoints, {
        y: (isNaN(+avannis) ? 0 : Number(avannis)),
        color: '#FFAA00',
        dataLabels: {
          enabled: Number(avannis) > 0, formatter() {
            return this.y + '%';
          }
        }
      }]
    }
    setHighchartsDataPoints(newDataPoints)
  }, [values])

  return (
    <Col className="ssd-question-chart">
      <Card>
        <span className="card-title" style={{ padding: '10px' }}>{small_text}</span>
        {
          highchartsDataPoints &&
          <div className="card-content">
            {
              values.length === 0 &&
              <ColumnChartComponent
                title={small_text}
                isLoading={false}
                legend={false}
                categories={values.reduce((acc, curr) => acc.concat(curr.display), [])}
                factor={'100'}
                seriesName={''}
                series={[]}
                avannisAvg={avannis}
                dataPoints={[]}
                htmlSubtitle={htmlSubtitle}
                noDataMessage={'There is no data for the selected criteria.'}
              />
            }
            {
              (values.length > 0 && values.length < 3) &&
              <ColumnChartComponent
                title={small_text}
                isLoading={false}
                legend={false}
                categories={
                  [...values.reduce((acc, curr) => acc.concat(curr.display), []), 'Avannis Avg']
                }
                factor={'100'}
                seriesName={''}
                series={[]}
                avannisAvg={avannis}
                dataPoints={highchartsDataPoints}
                htmlSubtitle={htmlSubtitle}
                noDataMessage={'There is no data for the selected criteria.'}
              />
            }
            {
              values.length >= 3 &&
              <AreaChartComponent
                title={small_text}
                isLoading={false}
                legend={false}
                categories={values.reduce((acc, curr) => acc.concat(curr.display), [])}
                factor={'100'}
                seriesName={''}
                series={[]}
                avannisAvg={avannis}
                dataPoints={highchartsDataPoints}
                htmlSubtitle={htmlSubtitle}
              />
            }
          </div>}
      </Card>
    </Col>
  );
}
